import React from "react";
import sanitizeHtml from "sanitize-html";
import { Button } from "nectar-ui";
import { NormalText } from "@components/styles/dataDisplay";

const HistoricalDescription = ({
  eventDescription,
  openModal,
}: {
  eventDescription?: string;
  openModal: () => void;
}) => {
  if (!eventDescription) return null;
  const MAX_CHARS = 130;

  const sanitizedDescription = sanitizeHtml(eventDescription);
  const shouldOpenModal = sanitizedDescription.length > MAX_CHARS;

  if (shouldOpenModal)
    return (
      <div style={{ display: "flex", columnGap: 4, flexWrap: "wrap", alignItems: "flex-end" }}>
        <NormalText
          id="description"
          dangerouslySetInnerHTML={{
            __html: sanitizedDescription.substring(0, 127).concat("..."),
          }}
        />
        <Button link onClick={openModal}>
          Ver mais
        </Button>
      </div>
    );

  return <NormalText>{eventDescription}</NormalText>;
};

export default HistoricalDescription;
